var link_viewer_default = {
  "fontElementMap": "V4Rou",
  "link": "DyYwg",
  "linkInEditor": "p52AQ",
  "linkInViewer": "MFzI-",
  "toolbarUrlContainer": "_9gq3N",
  "toolbarUrl": "-dzBl",
  "toolbarUrlAnchor": "_6JdP4"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
